import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type Order as SchemaOrder } from '../schemas/Order';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const GetOrderContentType = '' as const;
export type GetOrderRequest = void;
export type GetOrderResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful retrieval of data
     */
    '200': {
        'application/json': SchemaOrder;
    };
};
export type GetOrderResponseSuccess = GetOrderResponses['200']['application/json'];
export type GetOrderSearchParams = {
    signature: string;
};
export type GetOrderPathParameters = {
    store_slug: string;
    order_id: string;
};
export const GetOrderUrl = '/{store_slug}/orders/{order_id}' as const;
export const GetOrderMethod = 'GET' as const;
export const getGetOrderUrl = (params: GetOrderPathParameters) =>
    GetOrderUrl.replace(/\{(\w+)\}/g, (_match, param: keyof GetOrderPathParameters) => String(params[param]));
